import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { ref, computed } from 'vue';
	import { FilteredListEvent } from '@/types/components';

	type Props = {
		items: Array<Record<string, any>>;
		filterKey?: string;
		sortby: string;
		placeholder: string;
	};

	
export default /*#__PURE__*/_defineComponent({
  __name: 'FilteredList',
  props: {
    items: { default: () => [] },
    filterKey: { default: 'name' },
    sortby: { default: '' },
    placeholder: { default: 'Filter' }
  },
  emits: ['click', 'filter'],
  setup(__props: any, { emit: __emit }) {

	const emit = __emit;

	const filter = ref('');

	const props = __props;

	const filteredItems = computed(() => {
		const lcFilter = filter.value.toLowerCase();
		let items = props.items.filter((item: any) => {
			if (filter.value === '') {
				return true;
			}
			const lcItem = item[props.filterKey]?.toLowerCase();
			return lcItem.includes(lcFilter);
		});
		if (props.sortby !== '') {
			items = items.toSorted((a: Record<string, any>, b: Record<string, any>) => {
				return a[props.sortby].toLowerCase().localeCompare(b[props.sortby].toLowerCase());
			});
		}
		return items;
	});

	function changed() {
		filter.value = filter.value.toLocaleLowerCase();
		const event: FilteredListEvent = {
			filter: filter.value,
			length: filteredItems.value.length,
		};
		emit('filter', event);
	}

	function clickedItem(item: any) {
		emit('click', item);
	}

return (_ctx: any,_cache: any) => {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TextInput, {
      placeholder: _ctx.placeholder,
      modelValue: filter.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
      class: "mb-4 w-full",
      onChanged: _cache[1] || (_cache[1] = ($event: any) => (changed()))
    }, null, 8, ["placeholder", "modelValue"]),
    _renderSlot(_ctx.$slots, "subtitle"),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "group block cursor-pointer hover:bg-green p-1 rounded",
          onClick: ($event: any) => (clickedItem(item))
        }, [
          _renderSlot(_ctx.$slots, "item", _mergeProps({ ref_for: true }, { item }))
        ], 8, _hoisted_1))
      }), 128))
    ])
  ], 64))
}
}

})